/**
 * 供应商管理
 */
import { addEditDialog, logDialog } from './_dialogs'
import { UI_PAGE_EVENTS } from '@zto/zpage-ui-element'
import dayjs from 'dayjs'

export default {
  body: {
    type: 'crud',
    actions: {
      query: {
        api: '/cabinet/admin/base/AdminBaseSupplierQueryController/queryList'
      },
      add: {
        label: '新增供应商',
        api: '/cabinet/admin/base/AdminBaseSupplierCommandController/add',
        dialog: addEditDialog('add'),
        successMessage: '新增成功！'
      },
      edit: {
        label: '编辑',
        api: '/cabinet/admin/base/AdminBaseSupplierCommandController/edit',
        dialog: addEditDialog('edit'),
        successMessage: '编辑成功！'
      },
      view: {
        label: '详情',
        dialog: addEditDialog('view')
      },
      log: {
        label: '日志',
        dialog: logDialog
      }
    },
    searchOn: [UI_PAGE_EVENTS.ACTIVATED],
    search: {
      labelWidth: 100,
      items: [
        { type: 'input', prop: 'supplierName', label: '供应商名称', span: 6 },
        { type: 'input', prop: 'supplierCode', label: '供应商ID', span: 6 },
        { type: 'input', prop: 'contactPhone', label: '联系人手机号', span: 6 }
      ]
    },
    toolbar: {
      noExport: true,
      items: [{ action: 'add' }]
    },
    table: {
      operation: {
        width: 120,
        items: [{ action: 'edit' }, { action: 'view' }, { action: 'log' }]
      },
      columns: [
        { label: '供应商ID', prop: 'supplierCode', minWidth: 220 },
        { label: '供应商名称', prop: 'supplierName', minWidth: 180 },
        { label: '企业联系人', prop: 'contactName', minWidth: 150 },
        { label: '联系人手机号', prop: 'contactPhone', minWidth: 150 },
        { label: '创建人', prop: 'creator', minWidth: 150 },
        {
          label: '创建时间',
          minWidth: 150,
          formatter: (row: any) => {
            return dayjs(row.gmtCreate).format('YYYY-MM-DD HH:mm:ss') // 时间格式化
          }
        }
      ]
    }
  }
}
